// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"4c5370c6","990":"bae86c91"}[chunkId] + ".chunk.js";
};